module.exports = __webpack_public_path__ + "img/buildings_grey.7624c6e2.webp";